<template>
  <div>
    <left></left>
    <right></right>
  </div>
</template>

<script>

  import Left from './Left';
  import Right from './Right';

  export default {
    name: 'portfolio',
    components: {
      Left,
      Right,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Portfolio.vue?7eead79a